import { css } from "lit";

export const buttonStyles = css`
  :host {
    display: var(--wow-button-display, inline-block);
    width: var(--wow-button-width, auto);

    &.square {
      aspect-ratio: 1 / 1;
    }
  }

  :host([full-width]) {
    width: 100%;
  }

  .button {
    display: var(--wow-button-inner-display, inline-flex);
    width: var(--wow-button-inner-width, auto);
    justify-content: center;
    align-items: center;
    gap: var(--sds-size-space-200);
    padding: var(--sds-size-space-400) var(--sds-size-space-600);
    border: var(--sds-size-stroke-border) solid transparent;
    border-radius: var(--sds-size-radius-400);
    cursor: pointer;
    text-decoration: none;

    background: var(--sds-color-background-brand-default);
    color: var(--sds-color-text-neutral-on-neutral);

    font-weight: var(--sds-typography-weight-semibold);
    font-size: calc(var(--wow-button-inner-font-size, --sds-typography-body-size-large) / 100%);
    font-family: var(--sds-typography-family-title);

    &:hover {
      background: var(--sds-color-background-brand-hover);
    }

    &:disabled {
      border-color: var(--sds-color-border-disabled-default);
      background: var(--sds-color-background-disabled-default);
      color: var(--sds-color-text-disabled-on-disabled);
      cursor: not-allowed;
    }

    &.neutral {
      border-radius: var(--sds-size-radius-400);
      border-color: var(--sds-color-border-default-secondary);
      background: var(--sds-color-background-default-secondary);
      color: var(--sds-color-text-default-default);

      &:hover {
        background: var(--sds-color-background-default-secondary-hover);
      }

      &:disabled {
        color: var(--sds-color-text-disabled-on-disabled);
      }
    }

    &.subtle {
      padding: var(--sds-size-space-150);
      background: none;
      border: none;
      color: var(--sds-color-text-default-default);
    }

    &.danger {
      background: var(--sds-color-background-danger-default);
      color: var(--sds-color-text-danger-on-danger);

      &:hover {
        background: var(--sds-color-background-danger-hover);
      }
    }

    &.large {
      padding: var(--sds-size-space-600) var(--sds-size-space-800);
    }

    &.small {
      padding: var(--sds-size-space-200) var(--sds-size-space-400);
      font-size: var(--wow-button-inner-font-size, --sds-typography-body-size-medium);
    }

    &.square {
      aspect-ratio: 1 / 1;
      padding: var(--sds-size-space-400);

      &.large {
        padding: var(--sds-size-space-600);
      }

      &.small {
        padding: var(--sds-size-space-200);
      }
    }

    &::slotted([slot="preIcon"]) {
      margin-right: var(--sds-size-space-200);
      display: inline-block;
    }

    &::slotted([slot="sufIcon"]) {
      margin-left: var(--sds-size-space-200);
      display: inline-block;
    }

    &.full-width {
      width: 100%;
    }

    &.rounded {
      border-radius: var(--sds-size-radius-full);
      line-height: 1;
    }

    &.custom-color {
      &,
      &.primary,
      &.neutral,
      &.danger {
        color: var(--custom-color);
      }
    }

    &.custom-bg {
      background: var(--custom-bg-color);

      &:hover {
        background: var(--custom-bg-color-hover);
      }

      /* Override variant styles when custom background is used */
      &.primary,
      &.neutral,
      &.danger {
        background: var(--custom-bg-color);

        &:hover {
          background: var(--custom-bg-color-hover);
        }
      }
    }
  }
`;
